import Image from "next/image";
import { Images } from "@/assests";

interface LogoVariant {
  src: string;
  srcLight: string;
  w: number;
  h: number;
}

const PLATFORM_LOGOS: Record<string, LogoVariant> = {
  G2: {
    src: Images.reviewsMain.g2Card,
    srcLight: Images.reviewsMain.g2CardOnLight,
    w: 69,
    h: 26,
  },
  Trustpilot: {
    src: Images.trustpilotDark,
    srcLight: Images.trustpilotOnLight,
    w: 100,
    h: 26,
  },
};

export function PlatformLogo({ platform }: { platform: string }) {
  const logo = PLATFORM_LOGOS[platform];
  if (!logo) return <span className="text-muted-foreground text-xs font-semibold">{platform}</span>;
  return (
    <>
      <Image
        src={logo.src}
        alt={`${platform} logo`}
        width={logo.w}
        height={logo.h}
        className="light:hidden object-contain"
        style={{ height: "auto" }}
      />
      <Image
        src={logo.srcLight}
        alt=""
        width={logo.w}
        height={logo.h}
        className="light:block hidden object-contain"
        style={{ height: "auto" }}
      />
    </>
  );
}
